export function toKML(polygon) {
  const coords = polygon.coordinates
    .map((c) => `${c.x},${c.y},${c.z}`)
    .join(" ");
  return `<?xml version="1.0" encoding="UTF-8"?>
  <kml xmlns="http://www.opengis.net/kml/2.2">
    <Placemark>
      <name>${polygon.name}</name>
      <Style>
        <PolyStyle>
          <color>${
            polygon.polygonColor
              ? polygon.polygonColor.replace("#", "ff")
              : null
          }</color>
        </PolyStyle>
      </Style>
      <Polygon>
        <outerBoundaryIs>
          <LinearRing>
            <coordinates>${coords}</coordinates>
          </LinearRing>
        </outerBoundaryIs>
      </Polygon>
    </Placemark>
  </kml>`;
}
